import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AlertService } from './alert.service';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { AppUrl } from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class FinalExamEvaluatorSubjectService extends BaseService {
  constructor(
    public http: HttpClient,
    public alertService: AlertService,
    public globalService: GlobalService
  ) {
    super(http, alertService, globalService);
  }

  add(data: {}): Observable<any> {
    return this.postRequest(AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT(), data);
  }

  get(data: {}): Observable<any> {
    return this.getRequestWithoutErrorMessage(
      AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT(),
      data
    );
  }

  detail(uniqueId: any): Observable<any> {
    return this.getRequestWithoutErrorMessage(
      AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT(uniqueId)
    );
  }

  update(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT(uniqueId), data);
  }

  updateSubjects(data: {}, uniqueId: any): Observable<any> {
    return this.putRequest(
      AppUrl.INTERNAL_EXAM_EVALUATOR_UPDATE_SUBJECT(uniqueId),
      data
    );
  }

  delete(uniqueId: any): Observable<any> {
    return this.deleteRequest(AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT(uniqueId));
  }

  getResult(uniqueId: any): Observable<any> {
    return this.getRequest(
      AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT_STUDENT_RESULT(uniqueId)
    );
  }

  addResult(data: any, uniqueId: any): Observable<any> {
    return this.postRequest(
      AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT_STUDENT_RESULT(uniqueId),
      data
    );
  }

  getConsolidationResult(data: any): Observable<any> {
    return this.getRequest(AppUrl.CONSOLIDATION_STUDENT_RESULT(), data);
  }

  addConsolidationResult(data: any): Observable<any> {
    return this.postRequest(AppUrl.CONSOLIDATION_STUDENT_RESULT(), data);
  }

  downloadExcel(data: {}, uniqueId: any): Observable<any> {
    return this.getRequest(
      AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT_STUDENT_RESULT_EXCEL(uniqueId),
      data
    );
  }

  downloadConsolidationExcel(data: {}): Observable<any> {
    return this.getRequest(
      AppUrl.CONSOLIDATION_STUDENT_RESULT_EXCEL(),
      data
    );
  }

  deleteConsolidationResult(data: any): Observable<any> {
    return this.deleteRequest(AppUrl.CONSOLIDATION_STUDENT_RESULT(), data);
  }

  addMultiple(data: {}): Observable<any> {
    return this.postRequest(AppUrl.FINAL_EXAM_EVALUATOR_SUBJECT_MULTIPLE(), data);
  }

  checkConsolidationResult(data: {}): Observable<any> {
    return this.getRequestWithoutErrorMessage(AppUrl.CHECK_CONSOLIDATION_STUDENT_RESULT(), data);
  }

  generateResult(data: {}): Observable<any> {
    return this.postRequest(AppUrl.GENERATE_STUDENT_RESULT(), data);
  }

  markNotGenerateResult(data: {}): Observable<any> {
    return this.postRequest(AppUrl.MARK_NOT_GENERATE_STUDENT_RESULT(), data);
  }

  getGenerateResultStudent(data: {}): Observable<any> {
    return this.getRequest(AppUrl.GET_GENERATE_STUDENT_RESULT(), data);
  }

  declareResult(data: {}): Observable<any> {
    return this.postRequest(AppUrl.DECLARE_STUDENT_RESULT(), data);
  }

  downloadGeneratedResult(data: {}): Observable<any> {
    return this.getRequest(AppUrl.DOWNLOAD_GENERATED_STUDENT_RESULT(), data);
  }

  downloadGeneratedResultAll(data: {}): Observable<any> {
    return this.getRequest(AppUrl.DOWNLOAD_GENERATED_STUDENT_RESULT_ALL(), data);
  }

  viewResult(data: {}, unique_id: any): Observable<any> {
    return this.getRequest(AppUrl.VIEW_STUDENT_RESULT(unique_id), data);
  }

  getAvailableSemesters(data: {}, unique_id: any): Observable<any> {
    return this.getRequest(AppUrl.AVAILABLE_STUDENT_RESULT_SEMESTERS(unique_id), data);
  }

  updateStudentResult(data: {}, unique_id: any): Observable<any> {
    return this.postRequest(AppUrl.ADMIN_UPDATE_STUDENT_RESULT(unique_id), data);
  }

  downloadResultSummary(data: {}): Observable<any> {
    return this.getRequest(AppUrl.DOWNLOAD_GENERATE_RESULT_SUMMARY(), data);
  }
}
